(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["EU-Reifenlabel-Section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eu-label-texts')) {
    customElements.define('eu-label-texts', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        const buttons = this.querySelectorAll('.eu-rl-toggle');
        const descriptions = this.querySelectorAll('.eu-rl-description');
        const controlledIds = Array.from(descriptions, (text) => text.id).join(' ');

        buttons.forEach((button) => {
          button.setAttribute('aria-controls', controlledIds);

          button.addEventListener('click', () => {
            const expanded = this.classList.toggle('is-expanded');

            buttons.forEach((toggle) => {
              toggle.setAttribute('aria-expanded', String(expanded));
              toggle.textContent = expanded ? 'Weniger anzeigen' : 'Mehr anzeigen';
            });
          });
        });

        this.classList.add('is-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Hersteller-Konzerne"] && !Shopify.designMode) return;
  try {
    
(() => {
  const namespace = 'http://www.w3.org/2000/svg';
  const registered = new WeakSet();

  /*
   * Desktop-Schaubild als ruhige Baumstruktur:
   * Muttermarke ──(weiche S-Kurve)──┐ Stamm mit runden Ecken
   *                                 ├── Logo ── Logo   (Ast läuft mittig in die Zeile)
   *                                 └── Logo ── Logo
   * Die Äste laufen hinter den Logo-Kacheln durch (Kacheln haben einen Hintergrund),
   * dadurch sind auch die rechten Logos sauber angebunden.
   */
  const LINIE = '#8fb0da';

  function drawDesktop(chart) {
    const card = chart.closest('.markengruppe__mutter-card');
    const svg = card?.querySelector('.markengruppe__desktop-linien');
    const anchor = card?.querySelector('.markengruppe__mutter-bild') || card?.querySelector('.markengruppe__mutter-name');
    if (!svg || !anchor) return;

    const bounds = card.getBoundingClientRect();
    const rel = (el) => {
      const r = el.getBoundingClientRect();
      return {
        left: r.left - bounds.left,
        right: r.right - bounds.left,
        cy: r.top + r.height / 2 - bounds.top
      };
    };

    // Pro Zeile: Mittelhöhe + linke Kante des letzten Logos (bis dorthin läuft der Ast)
    const rows = [...chart.querySelectorAll('.markengruppe__schaubild-reihe')]
      .map((row) => [...row.querySelectorAll('.markengruppe__schaubild-logo')].map(rel))
      .filter((logos) => logos.length)
      .map((logos) => ({
        y: logos[0].cy,
        first: Math.min(...logos.map((l) => l.left))
      }))
      // Ast endet am ersten Logo der Reihe
      .map((r) => ({ ...r, end: r.first - 5 }));
    if (!rows.length) return;

    svg.setAttribute('viewBox', `0 0 ${bounds.width} ${bounds.height}`);
    svg.replaceChildren();

    const add = (tag, attrs) => {
      const el = document.createElementNS(namespace, tag);
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
      svg.appendChild(el);
      return el;
    };
    const line = (d, opacity = 0.85) => add('path', {
      d,
      fill: 'none',
      stroke: LINIE,
      'stroke-width': 1.6,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      opacity
    });

    const a = rel(anchor);
    const rootX = a.right + 16;
    const rootY = a.cy;
    const spineX = Math.min(...rows.map((r) => r.first)) - 26;
    const top = rows[0].y;
    const bottom = rows.at(-1).y;
    const radius = Math.max(0, Math.min(14, (bottom - top) / 2));

    // Andockpunkt am Stamm: auf Höhe der Muttermarke, aber innerhalb des Stamms
    const joinY = rows.length > 1
      ? Math.min(Math.max(rootY, top + radius), bottom - radius)
      : top;

    // 1) Weiche S-Kurve von der Muttermarke zum Stamm (beide Tangenten waagerecht)
    const dx = Math.max(spineX - rootX, 0);
    line(`M ${rootX} ${rootY} C ${rootX + dx * 0.55} ${rootY}, ${spineX - dx * 0.55} ${joinY}, ${spineX} ${joinY}`);

    if (rows.length === 1) {
      line(`M ${spineX} ${top} L ${rows[0].end} ${top}`);
    } else {
      // 2) Stamm als durchgehende Klammer mit abgerundeten Ecken oben und unten
      line(
        `M ${rows[0].end} ${top} L ${spineX + radius} ${top} ` +
        `Q ${spineX} ${top} ${spineX} ${top + radius} ` +
        `L ${spineX} ${bottom - radius} ` +
        `Q ${spineX} ${bottom} ${spineX + radius} ${bottom} ` +
        `L ${rows.at(-1).end} ${bottom}`
      );
      // 3) Mittlere Zeilen als gerade Äste
      rows.slice(1, -1).forEach((r) => line(`M ${spineX} ${r.y} L ${r.end} ${r.y}`));
    }

    // Kleine Andockpunkte vor jeder Reihe
    rows.forEach((r) => add('circle', { cx: r.end, cy: r.y, r: 2.6, fill: LINIE }));

    // Knoten an der Muttermarke
    add('circle', { cx: rootX, cy: rootY, r: 4, fill: '#ffffff', stroke: LINIE, 'stroke-width': 1.6 });
  }

  function draw(chart) {
    if (getComputedStyle(chart).display === 'none') return;
    const svg = chart.querySelector('.markengruppe__schaubild-linien');
    const parent = chart.querySelector('.markengruppe__schaubild-mutter');
    const rows = [...chart.querySelectorAll('.markengruppe__schaubild-reihe')];
    if (!svg || !parent || !rows.length) return;
    if (getComputedStyle(parent).display === 'none') {
      drawDesktop(chart);
      return;
    }

    const bounds = chart.getBoundingClientRect();
    const parentBounds = parent.getBoundingClientRect();
    const center = parentBounds.left + parentBounds.width / 2 - bounds.left;
    const top = parentBounds.bottom - bounds.top;
    const lastBounds = rows.at(-1).querySelector('.markengruppe__schaubild-logo').getBoundingClientRect();
    const lastY = lastBounds.top - bounds.top;
    svg.setAttribute('viewBox', `0 0 ${bounds.width} ${bounds.height}`);
    svg.replaceChildren();

    function path(d, opacity) {
      const line = document.createElementNS(namespace, 'path');
      line.setAttribute('d', d);
      line.setAttribute('fill', 'none');
      line.setAttribute('stroke', LINIE);
      line.setAttribute('stroke-width', '1.6');
      line.setAttribute('stroke-linecap', 'round');
      line.setAttribute('opacity', opacity);
      svg.appendChild(line);
    }

    path(`M ${center} ${top} L ${center} ${lastY}`, '0.48');
    rows.forEach((row) => {
      row.querySelectorAll('.markengruppe__schaubild-logo').forEach((logo) => {
        const rect = logo.getBoundingClientRect();
        const x = rect.left + rect.width / 2 - bounds.left;
        const y = rect.top - bounds.top;
        if (Math.abs(x - center) < 1) return;
        const start = y - 23;
        path(`M ${center} ${start} C ${center} ${y - 5}, ${x} ${y - 20}, ${x} ${y}`, '0.7');
      });
    });
  }

  function init(root = document) {
    root.querySelectorAll('.markengruppe__schaubild').forEach((chart) => {
      if (registered.has(chart)) return;
      registered.add(chart);
      const observer = new ResizeObserver(() => draw(chart));
      observer.observe(chart);
      const card = chart.closest('.markengruppe__mutter-card');
      observer.observe(card);
      // Lazy-geladene Logos verändern die Positionen – danach neu zeichnen
      card.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => draw(chart), { once: true });
      });
      draw(chart);
    });
  }

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Produkt-Metafeld-Tabelle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mf-info-table')) {
    customElements.define('mf-info-table', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;

        const dialog = this.querySelector('dialog');
        const title = dialog.querySelector('.mf-info__modal-title');
        const body = dialog.querySelector('.mf-info__modal-body');
        const list = this.querySelector('.mf-info__list');
        const more = this.querySelector('.mf-info__more');

        this.addEventListener('click', (e) => {
          const key = e.target.closest('.mf-info__key');
          if (!key) return;
          title.textContent = key.dataset.title;
          body.innerHTML =
            (key.dataset.desc ? '<p>' + key.dataset.desc + '</p>' : '') +
            '<p>Der Reifen hat folgenden Wert: ' + key.nextElementSibling.innerHTML + '</p>';
          dialog.showModal();
        });

        dialog.querySelector('.mf-info__close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (e) => {
          if (e.target === dialog) dialog.close();
        });

        if (more) {
          more.addEventListener('click', () => {
            const open = list.classList.toggle('is-open');
            more.setAttribute('aria-expanded', String(open));
            more.textContent = open ? 'Weniger anzeigen' : 'Mehr anzeigen';
          });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
